import adapter from '../adapter-blog-archive';
var IDs = adapter.IDs, SchemaTypes = adapter.SchemaTypes;
export default {
    type: SchemaTypes.BLOG_ARCHIVE_ITEM_LIST,
    schema: "{{" + IDs.SD_JSON_RENDER + "}}",
};
